module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"transplant_details":"Transplant Details","summary":"Summary","return_to_prev":"Return to previous page","profile":"Profile"},"fr":{"transplant_details":"Détails de la transplantation","summary":"Résumé","return_to_prev":"Retourner à la page précédente","profile":"Profil"}}')
  delete Component.options._Ctor
}
